import { GlobalResponseObject } from "../../../global-response-object";
import { LineWorkStationEfficiencyModel } from "./line-workstation-efficiency.model";

export class LineWorkstationEfficiencyResponse extends GlobalResponseObject{
    data?: LineWorkStationEfficiencyModel;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LineWorkStationEfficiencyModel){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

